import { render, staticRenderFns } from "./CourseAgreement.vue?vue&type=template&id=4c2b6270&"
import script from "./CourseAgreement.vue?vue&type=script&lang=js&"
export * from "./CourseAgreement.vue?vue&type=script&lang=js&"
import style0 from "./CourseAgreement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports